import React from 'react';
import InputV1 from '../../../../../components/ComponentsV1/InputV1';
import { Star } from '../../../../../UiKit/Star/Star';
import { FIELD_TYPE } from '../constants';
import { buildDropdownOptions } from '../utils';

const DynamicField = ({ field, value, onChange }) => {
  if (!field?.name) return null;

  return (
    <div className={`tw-flex tw-flex-col tw-gap-2 tw-min-w-[350px] ${field.type === FIELD_TYPE.BOOL ? 'tw-w-full' : 'tw-flex-1/2'}`}>
      {field.type !== FIELD_TYPE.BOOL && (
        <div className='tw-font-medium tw-text-500'>
          {field.label ?? field.name}
          {field.required && <Star icon='*' />}
        </div>
      )}
      {field.type === FIELD_TYPE.BOOL ? (
        <label className='tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-h-14 tw-w-fit'>
          <input
            type='checkbox'
            checked={Boolean(value)}
            onChange={(event) => onChange(event.target.checked)}
          />
          <span>{field.label ?? 'Yes'}</span>
        </label>
      ) : field.type === FIELD_TYPE.SELECT ? (
        <InputV1
          options={buildDropdownOptions(field.options, 'value', 'label')}
          placeholder={field.placeholder ?? ''}
          multiple={false}
          isSearchable
          inputProps={{
            className: 'tw-border-none',
            type: 'text',
            style: { width: '100%' },
          }}
          style={{ width: '100%', display: 'block' }}
          closeOnSelect
          onSelect={(option) => onChange?.(option?.value)}
          value={value}
        />
      ) : (
        <InputV1
          inputProps={{
            type: 'text',
            name: field.name,
            placeholder: field.placeholder ?? '',
            className: 'tw-border-none',
            style: { width: '100%' },
          }}
          value={value ?? ''}
          onChange={onChange}
          style={{ width: '100%', display: 'block' }}
        />
      )}
      {field.type !== FIELD_TYPE.BOOL && field.help_text && (
        <p className='tw-text-grey-500 tw-text-300 tw-m-0'>{field.help_text}</p>
      )}
    </div>
  );
};

export default DynamicField;
